import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

/**
 * Fixed reporting window: 12 complete calendar months ending last month
 * (matches location-reports; excludes the in-progress current month).
 *
 * start / end / label / monthKeys are derived together so the chart axis
 * cannot drift from the subtitle.
 */
export function getLast12MonthsReportPeriod(referenceDate = dayjs()) {
    const endMonth = dayjs(referenceDate).startOf("month").subtract(1, "month");
    const startMonth = endMonth.subtract(11, "month");
    const monthKeys = [];
    for (let i = 0; i < 12; i += 1) {
        monthKeys.push(startMonth.add(i, "month").format("YYYY-MM"));
    }
    return {
        start: startMonth.startOf("month"),
        end: endMonth.endOf("month"),
        monthKeys,
        label: `${formatMonthAxisLabel(monthKeys[0], "MMM YYYY")} – ${formatMonthAxisLabel(monthKeys[11], "MMM YYYY")}`,
    };
}

/** Month keys for chart labels (YYYY-MM), oldest first. */
export function buildLast12MonthKeys(referenceDate = dayjs()) {
    return getLast12MonthsReportPeriod(referenceDate).monthKeys;
}

/**
 * Format YYYY-MM for chart axes without timezone day-shift
 * (date-only local parse / UTC midnight can move Jul → Jun in western zones).
 */
export function formatMonthAxisLabel(monthKey, pattern = "MMM YY") {
    const match = /^(\d{4})-(\d{2})$/.exec(`${monthKey}`.trim());
    if (!match) {
        return `${monthKey}`;
    }
    return dayjs.utc(`${match[1]}-${match[2]}-15T12:00:00Z`).format(pattern);
}

/** Previous complete calendar month (e.g. June 2026 when now is July 2026). */
export function getPreviousCalendarMonthPeriod(referenceDate = dayjs()) {
    const start = dayjs(referenceDate).subtract(1, "month").startOf("month");
    const end = dayjs(referenceDate).subtract(1, "month").endOf("month");
    return {
        start,
        end,
        label: start.format("MMMM YYYY"),
        dayCount: end.date(),
    };
}
